import apiClient from "./apiClient";
import { downloadBlob } from "@/utils/downloadBlob";

const BASE_URL = `${process.env.VUE_APP_BASE_URL as string}/api/v1/duplicates`;

export type ChildDuplicateStatus = "PENDING" | "CONFIRMED_DUPLICATE" | "FALSE_DUPLICATE";

export const STATUS_LABELS: Record<ChildDuplicateStatus, string> = {
  PENDING: "Ожидает решения",
  CONFIRMED_DUPLICATE: "Подтверждён дубль",
  FALSE_DUPLICATE: "Проверено — ложный дубль",
};

export interface ChildDuplicateSearchParams {
  page: number;
  pageSize: number;
  accountingYear: number;
  accountingMonth: number;
  katoCode?: number | null;
  lmsName?: string | null;
  status?: ChildDuplicateStatus | null;
  childKey?: string | null;
  /** пересчитать дубли, не дожидаясь истечения серверного кеша (5 мин) */
  refresh?: boolean;
}

export interface KindergartenSide {
  name: string;
  bin: string;
  lmsId: string;
  lmsName: string | null;
  katoCode: number | null;
  amount: number | null;
  arrived: string | null;
  departure: string | null;
}

export interface ChildDuplicateRow {
  childKey: string;
  fio: string;
  kindergartenCount: number;
  kg1: KindergartenSide;
  kg2: KindergartenSide;
  totalAmount: number;
  overlapDays: number;
  status: ChildDuplicateStatus;
  comment: string | null;
  reviewedBy: string | null;
  reviewedByName: string | null;
  reviewedAt: string | null;
  stale: boolean;
}

export interface ChildDuplicatePage {
  content: ChildDuplicateRow[];
  totalElements: number;
  summary: { children: number; totalAmount: number; pending: number };
}

export async function findDuplicates(params: ChildDuplicateSearchParams): Promise<ChildDuplicatePage> {
  const response = await apiClient.post<ChildDuplicatePage>(`${BASE_URL}/list`, params);
  return response.data;
}

export async function changeDuplicateStatus(row: ChildDuplicateRow, year: number, month: number, status: ChildDuplicateStatus, comment: string): Promise<ChildDuplicateRow> {
  const response = await apiClient.put<ChildDuplicateRow>(`${BASE_URL}/${encodeURIComponent(row.childKey)}/${year}/${month}/status`, { status, comment });
  return response.data;
}

export async function exportDuplicates(params: ChildDuplicateSearchParams): Promise<void> {
  const response = await apiClient.post(`${BASE_URL}/export`, params, { responseType: "blob" });
  downloadBlob(response, `Dubli_IIN_Deti_${params.accountingYear}_${String(params.accountingMonth).padStart(2, "0")}.xlsx`);
}
